import { render, staticRenderFns } from "./TerminateAffiliationModal.vue?vue&type=template&id=49c31658&scoped=true&"
import script from "./TerminateAffiliationModal.vue?vue&type=script&lang=js&"
export * from "./TerminateAffiliationModal.vue?vue&type=script&lang=js&"
import style0 from "./TerminateAffiliationModal.vue?vue&type=style&index=0&id=49c31658&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c31658",
  null
  
)

component.options.__file = "TerminateAffiliationModal.vue"
export default component.exports